import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../../../assets/img/icons/close.svg'


const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-30" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = { class: "fs-18 mb-35 text-title fw-semibold" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_6 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ps-0 ls-1"
}
const _hoisted_7 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ls-1"
}
const _hoisted_8 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ls-1"
}
const _hoisted_9 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ls-1"
}
const _hoisted_10 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ls-1"
}
const _hoisted_11 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ls-1"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ls-1"
}
const _hoisted_13 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ls-1"
}
const _hoisted_14 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ls-1 text-end pe-0"
}
const _hoisted_15 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph ps-0" }
const _hoisted_16 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_17 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_18 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_19 = { class: "badge badge-success fw-semibold fs-14" }
const _hoisted_20 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_21 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_22 = {
  class: "input-group input-group-sm",
  style: {"width":"120px"}
}
const _hoisted_23 = ["value", "onInput"]
const _hoisted_24 = ["value", "onChange"]
const _hoisted_25 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_26 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_27 = { class: "shadow-none lh-1 text-end pe-0" }
const _hoisted_28 = { class: "button-group style-two ms-auto d-flex flex-wrap align-items-center" }
const _hoisted_29 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuantityCounter = _resolveComponent("QuantityCounter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.$t("sales_page.selected_products_for_sales")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("sales_page.product")), 1),
              _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("sales_page.code")), 1),
              _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("sales_page.unit_price")), 1),
              _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("sales_page.stock")), 1),
              _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("sales_page.quantity")), 1),
              _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("sales_page.discount")), 1),
              _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("sales_page.tax")), 1),
              _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("sales_page.subtotal")), 1),
              _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("sales_page.delete")), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: product.id
              }, [
                _createElementVNode("td", _hoisted_15, _toDisplayString(product.product), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(product.code), 1),
                _createElementVNode("td", _hoisted_17, " $ " + _toDisplayString(product.cost), 1),
                _createElementVNode("td", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(product.stock), 1)
                ]),
                _createElementVNode("td", _hoisted_20, [
                  _createVNode(_component_QuantityCounter, {
                    "model-value": product.qty,
                    "onUpdate:modelValue": (q) => _ctx.updateQty(product.id, q)
                  }, null, 8, ["model-value", "onUpdate:modelValue"])
                ]),
                _createElementVNode("td", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("input", {
                      type: "number",
                      class: "form-control form-control-sm border-end-0",
                      value: product.discount,
                      onInput: (e) => _ctx.updateDiscount(product.id, Number((e.target as HTMLInputElement).value), product.discount_type as 'fixed' | 'percentage')
                    }, null, 40, _hoisted_23),
                    _createElementVNode("select", {
                      class: "form-select form-select-sm bg-light",
                      style: {"max-width":"50px","padding-left":"5px","padding-right":"5px"},
                      value: product.discount_type,
                      onChange: (e) => _ctx.updateDiscount(product.id, product.discount, (e.target as HTMLSelectElement).value as 'fixed' | 'percentage')
                    }, [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("option", { value: "fixed" }, "$", -1),
                      _createElementVNode("option", { value: "percentage" }, "%", -1)
                    ]))], 40, _hoisted_24)
                  ])
                ]),
                _createElementVNode("td", _hoisted_25, " $ " + _toDisplayString(product.tax), 1),
                _createElementVNode("td", _hoisted_26, " $ " + _toDisplayString(product.subTotal.toFixed(2)), 1),
                _createElementVNode("td", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("a", {
                      class: "delete-btn",
                      href: "javascript:void(0)",
                      role: "button",
                      onClick: _withModifiers(($event: any) => (_ctx.removeProduct(product.id)), ["prevent"])
                    }, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: "Image"
                      }, null, -1)
                    ]))], 8, _hoisted_29)
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}